import React from 'react';
import { Lock } from 'lucide-react';

const NavItem = ({
    icon: Icon,
    label,
    targetPage,
    isPremiumFeature = false,
    page,
    navigate,
    isSidebarCollapsed,
    user
}) => {
    const isActive = page === targetPage;
    return (
        <div className="relative group">
            <button
                onClick={() => {
                    console.log('🧭 NavItem clicked:', { label, targetPage, currentPage: page, userRole: user?.role });
                    navigate(targetPage);
                }}
                className={`flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-purple-600 text-white shadow-lg' : 'text-purple-100 hover:bg-purple-700 hover:text-white'} ${isSidebarCollapsed ? 'justify-center' : ''}`}
                title={isSidebarCollapsed ? label : undefined}
            >
                <div className={`flex items-center ${isSidebarCollapsed ? 'justify-center' : ''}`}>
                    <Icon size={20} className={isSidebarCollapsed ? '' : 'mr-4'} />
                    {!isSidebarCollapsed && <span className="font-medium">{label}</span>}
                </div>
                {!isSidebarCollapsed && isPremiumFeature && !user.isPremium && <Lock size={14} className="text-purple-300" />}
            </button>
            {/* Tooltip saat collapsed */}
            {isSidebarCollapsed && (
                <div className="absolute left-full ml-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50 whitespace-nowrap">
                    {label}
                    {isPremiumFeature && !user.isPremium && (
                        <div className="absolute top-0 right-0 -mt-1 -mr-1">
                            <Lock size={12} className="text-yellow-400" />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default NavItem;
